import React from 'react';
import PropTypes from 'prop-types';
import InlineDealerPage from "../../components/InlineDealer/InlineDealerPage";

const DealerRanking = ({item}) => {

    const url = item.url.internalPath.split('/');
    const id = Number(url[url.length-1]);
    return (
        <div className="dealerRanking">
            <h1>{item.label}</h1>

            <InlineDealerPage pageID={`${id}`} gridType="vertical" />
        </div>
    );
};

DealerRanking.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    item: PropTypes.object.isRequired
};

export default DealerRanking;



// WEBPACK FOOTER //
// ./frontend/pages/DealerRankings/DealerRanking.jsx